import siteLogo from "../../../../assets/images/logo.png";
import Input from "../../../../components/form/Input";
import Button from "../../../../components/form/Button";
import useForm from "../../../../hooks/useForm";
import { formValidate } from "../../../../helpers/formValidate";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { login } from "../../../../redux/slice/authSlice";
import { useDispatch } from "react-redux";
import adminbg from "../../../../assets/images/adminbg.jpg";
import Image from "../../../../components/elements/Image";

const validation = {
  email: [
    {
      type: "email",
      required: true,
      message: "Enter valid Email",
    },
  ],
  password: [
    {
      type: "password",
      minLength: 8,
      required: true,
      message:
        "Password must be strong (min 8 characters, including uppercase, lowercase, number, and symbol)",
    },
  ],
};
const Login = () => {
  const { loginPending, loginData } = useSelector(
    (state) => state?.authProvider,
  );
  const dispatch = useDispatch();
  const location = useLocation();

  const { values, handleChange, handleSubmit, errors, setFieldsValue } =
    useForm({ validationRules: validation });

  const navigate = useNavigate();
  const settings = useSelector((state) => state?.settings?.data);

  const handleClick = () => {
    navigate("/admin/forgot-password", {
      state: "admin",
    });
  };

  return (
    <div className="w-full min-h-screen bg-slate-50 flex items-center justify-center py-3 px-5 relative">
      <div className="absolute w-full h-full top-0">
        <Image src={adminbg} alt={""} className="w-full h-full object-cover" />
      </div>
      <div className="w-full max-w-md xl:max-w-[430px] bg-gradient-to-b from-slate-100 to-primary/20 pt-11 pb-2 shadow-md border-l-2 border-primary absolute z-10 rounded-r-xl">
        <div className="flex min-h-full flex-1 flex-col justify-center px-2 py-4 lg:px-2">
          <div className="sm:mx-auto sm:w-full sm:max-w-sm">
            <div className="mt-[-34px] mb-[20px]">
              <img
                className="mx-auto h-12 w-auto"
                src={siteLogo}
                alt="Your Company"
              />
            </div>
            <h2 className="mt-1 uppercase text-center text-md font-bold leading-9 tracking-tight text-primary">
              Admin Login
            </h2>
            <h2 className="mt-1 text-center text-base font-semibold leading-9 tracking-tight text-black mb-4">
              Authorized Personnel Only.
            </h2>
          </div>

          <div className="mt-2 sm:mx-auto sm:w-full sm:max-w-sm">
            <form
              onSubmit={(event) =>
                handleSubmit(event, (val) => {
                  localStorage.setItem("lang", "en");
                  dispatch(
                    login({
                      ...val,
                      type: "admin",
                      redirect: "/admin/jobs",
                      location,
                      navigate,
                    }),
                  );
                })
              }
            >
              <div className="mt-2">
                <Input
                  label={"Email"}
                  inputPlaceholder={"Enter your email"}
                  labelClasses={"!text-xs !ml-3"}
                  inputType={"text"}
                  value={values.email}
                  inputName={"email"}
                  inputClasses={"!rounded-3xl !h-12"}
                  onChange={handleChange}
                  {...formValidate(errors, "email")}
                />
              </div>

              <div>
                <div className="mt-2">
                  <Input
                    label={"Password"}
                    inputPlaceholder={"Enter your password"}
                    labelClasses={"!text-xs !ml-3"}
                    inputType={"password"}
                    value={values.password}
                    inputName={"password"}
                    inputClasses={"!rounded-3xl !h-12"}
                    onChange={handleChange}
                    {...formValidate(errors, "password")}
                  />
                </div>
              </div>

              <div className="mt-2">
                <Button
                  loading={loginPending}
                  buttonHasLink={false}
                  buttonType={"submit"}
                  buttonLabel={"Log in"}
                  buttonIconPosition={"left"}
                  buttonIcon={"fa-light fa-right-to-bracket"}
                  buttonClasses={
                    "w-full !text-white !bg-primary !hover:bg-white !hover:text-primary focus-visible:outline justify-center rounded-md border border-primary !rounded-3xl !h-12"
                  }
                />
              </div>
              {loginData?.status && loginData?.status !== 200 && (
                <div className="text-center text-primary text-xs mt-1">
                  {loginData?.message}
                </div>
              )}
              <div className="flex justify-end">
                <Button
                  buttonClasses={
                    "!justify-right !bg-transparent !text-slate-500 border-none"
                  }
                  buttonHasLink={false}
                  buttonType={"button"}
                  buttonLabel={"Forgot Password?"}
                  buttonFunction={handleClick}
                />
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
